import { ValidationInterface } from '../../validation.interface';
import { ProjectValidationUnit } from '../../../../models/data-structures/project-validation';
import { Fuel, FuelInterface, FuelPropName } from '../../../../models/project/plant-specifications/fuel.model';
import { UnitValueValidation } from '../unit-value.validation';

export class FinancialFuelValidation implements ValidationInterface {
  private readonly fuel: Fuel;

  constructor(fuel: FuelInterface) {
    if (!fuel) throw Error('invalid fuel provided for fuel financial validation');
    this.fuel = new Fuel(fuel);
  }

  getValidation(): ProjectValidationUnit {
    if (!this.fuel) throw Error('unable to validate product financial');
    const validationUnit = new ProjectValidationUnit();
    validationUnit.addModuleResults(
      new UnitValueValidation(this.fuel.cost).getValidation(),
      FuelPropName.cost
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.fuel.amount).getValidation(),
      FuelPropName.quantity
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.fuel.cpi).getValidation(),
      FuelPropName.cpi
    );
    return validationUnit;
  }

  isValid(): boolean {
    return this.getValidation().isValid;
  }
}
